import PropTypes from 'prop-types';
import React from 'react';
import QRCode from 'react-qr-code';

const GreeceSpecificFooter = ({
  locale,
  GreeceFiscalValues,
  isGiftReceipt
}) => {
  const {
 VendorUID, FiscalNumber, AuthenticationCode, FiscalSignature, ProviderName, FiscalQRCode
} = GreeceFiscalValues || {};

  if (locale !== 'el-GR' || isGiftReceipt) return <></>;

  return (
    <section>
      {VendorUID && <article className="justify-between align-left"><p>UID={VendorUID}</p></article>}
      {FiscalNumber && <article className="justify-between align-left"><p>&nbsp;&nbsp;MARK={FiscalNumber}</p></article>}
      {FiscalQRCode && (
        <div className="d-sm-flx flx-ai-sm-c p2-sm" style={{ justifyContent: 'center' }}>
          <QRCode size={100} value={FiscalQRCode} />
        </div>
      )}
      {AuthenticationCode && <article className="justify-between align-left"><p>AuthenticationCode={AuthenticationCode}</p></article>}
      {FiscalSignature && <article className="justify-between align-left"><p>&nbsp;&nbsp;Упоурафі : {FiscalSignature}</p></article>}
      {ProviderName && <article className="justify-between align-left"><p>&nbsp;&nbsp;PROVIDER NAME={ProviderName}</p></article>}
      <br /><br />
    </section>
  );
};

GreeceSpecificFooter.defaultProps = {
  GreeceFiscalValues: {}
};

GreeceSpecificFooter.propTypes = {
  GreeceFiscalValues: PropTypes.shape(),
  isGiftReceipt: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired
};

export default GreeceSpecificFooter;
